import useEventListener from "./useEventListener";
import { useCallback, useEffect, useRef, useState } from 'react'

const useElementDimensions = (dependency = []) => {
  const ref = useRef(null)
  const [dimensions, setDimensions] = useState(null)

  const refresh = useCallback(() => {
    const domRect = ref.current?.getBoundingClientRect();

    if (domRect) {
      setDimensions(domRect);
    }
  }, [])

  useEffect(() => {
    const timeout = setTimeout(() => {
      const domRect = ref.current?.getBoundingClientRect();

      if (domRect) {
        setDimensions(domRect);
      }
    }, 300)
    return () => clearTimeout(timeout);
  }, [dependency]);

  useEventListener('resize', refresh);
  useEventListener('scroll', refresh, true);

  return { dimensions, ref, refresh }
}

export default useElementDimensions